<div class="menu-settings-tlhex position-relative">

	<!--LEFT MENU COMPONENTS-->
	@if (stateDescription?.isWorkflowRunning == workflowEnum.none && !isViewerVisible) {
	<tools-menu />
	}
	@if (stateDescription?.isWorkflowRunning == workflowEnum.none && isViewerVisible) {
	<viewer />
	}
	@if (stateDescription?.isWorkflowRunning == workflowEnum.insertOsteotomy) {
	<osteotomy-workflow />
	}
	@if (stateDescription?.isWorkflowRunning == workflowEnum.insertInsertionPoint) {
	<insertion-point-workflow />
	}
	@if (stateDescription?.isWorkflowRunning == workflowEnum.insertFitbone) {
	<template-selection />
	}

	<!--RIGHT MENU - DRAWER-->
	<drawer />

</div>